<!-- Menu superior de whatsaap -->

<img src="assets/user-avatar.png" class="imgSize" (click)="redirectHome()">
<span (click)="showDevice()" style="font-size: 14px; color: rgb(50, 153, 223); cursor: pointer;
    margin-left: 3px;">
    {{ 'CHAT_ICON_DEVICES' | translate}} <i [ngClass]="dev ? 'pi pi-angle-up' : 'pi pi-angle-down'" class="icnCstColor"></i>
</span>



<span class="frmt10">
    <i class="pi pi-home topBarIcons" pTooltip="{{ 'CHAT_ICON_HOME' | translate}}" tooltipPosition="top" (click)="redirectHome()"></i>
    <i class="pi pi-comment topBarIcons" pTooltip="{{ 'CHAT_ICON_NEW_CHAT' | translate}}" tooltipPosition="top"
        (click)=" newChatsModal()"></i>
    <i class="pi pi-search topBarIcons" pTooltip="{{ 'CHAT_ICON_SEARCH_CHAT' | translate}}" tooltipPosition="top" (click)="openSearch()"></i>
    <i *ngIf="!sh" class="pi pi-comments topBarIcons" pTooltip="{{ 'CHAT_ICON_SHOW_CHATS_LIST' | translate}}" tooltipPosition="top"
        (click)="openCon()"></i>
</span>

<div style="margin-top: 3px;">
    <span *ngIf="nombreToken"
    style="padding: .2rem .4rem;background-color: lightslategray;color: whitesmoke;margin-left: .3rem;border-radius: .5rem;letter-spacing: .1rem;font-size: 14px;">
    {{nombreToken}}
</span>
</div>